import React from 'react';
import {
  createStyles, makeStyles, Theme, useTheme,
} from '@material-ui/core/styles';
import {
  AppBar, Toolbar, useMediaQuery,
} from '@material-ui/core';

import MainBarContentSm from './MainBarContentSm';
import MainBarContentLg from './MainBarContentLg';

const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({
  root: {
    backgroundColor: colors.navigation,
    borderBottom: `2px solid ${palette.menuAction.hover}`,
    width: '100vw',
    zIndex: 2147483100,
  },
  toolbar: {
    justifyContent: 'center',
  },
}), { name: 'MainBar' });

const MainBar = () => {
  const classes = useStyles();

  const theme = useTheme();
  const compact = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar position="sticky" className={classes.root}>
      <Toolbar className={classes.toolbar}>
        {compact ? <MainBarContentSm /> : <MainBarContentLg /> }
      </Toolbar>
    </AppBar>
  );
};

export default MainBar;
